var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_423_35682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5563 3.00024H4.5375C3.71719 3.00024 3 3.59087 3 4.40181V19.4534C3 20.269 3.71719 20.9956 4.5375 20.9956H19.5516C20.3766 20.9956 20.9953 20.2643 20.9953 19.4534V4.40181C21 3.59087 20.3766 3.00024 19.5563 3.00024ZM8.57812 18.0002H6V9.98462H8.57812V18.0002ZM7.37812 8.76587H7.35938C6.53437 8.76587 6 8.15181 6 7.38306C6 6.60024 6.54844 6.00024 7.39219 6.00024C8.23594 6.00024 8.75156 6.59556 8.77031 7.38306C8.77031 8.15181 8.23594 8.76587 7.37812 8.76587ZM18 18.0002H15.4219V13.6174C15.4219 12.5674 15.0469 11.8502 14.1141 11.8502C13.4016 11.8502 12.9797 12.3331 12.7922 12.8018C12.7219 12.9706 12.7031 13.2002 12.7031 13.4346V18.0002H10.125V9.98462H12.7031V11.1002C13.0781 10.5659 13.6641 9.79712 15.0281 9.79712C16.7203 9.79712 18 10.9127 18 13.3174V18.0002Z",
    fill: "#DFE1E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_423_35682",
    x: 3,
    y: 3.00024,
    width: 17.9951,
    height: 17.9954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_423_35682"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.965f581a976911f7e7ccf17749febdc6.svg";
export { ForwardRef as ReactComponent };